export default __webpack_public_path__ + "static/media/ic-close-tambah-antrian.1d33e3bc.svg";